import React from 'react'
import {useIntl} from 'react-intl'
import {InnerSidebar} from '../../widgets/components/General/InnerSidebar'
import {InvestorSidebarOptions} from '../../../core/_constants'
import {InvestorUpdatesModel} from '../../investor-updates/core/_models'
import {useDateFormat} from '../../../hooks/useDateFormat'
import {DateTime} from 'luxon'
// import {DisplayImage} from '../../widgets/components/General/DisplayImage'
import {useNavigate} from 'react-router-dom'
import {OverlayTrigger} from 'react-bootstrap'
import {Tooltip} from 'react-bootstrap'
import {GET_FILE_URL} from '../../onboarding/core/_requests'

export const Update = ({
  investorUpdatesData,
  selectedOption,
  setSelectedOption,
}: {
  investorUpdatesData: any
  selectedOption: number
  setSelectedOption: any
}) => {
  const {formatMessage} = useIntl()
  const {updateSidebarOptions} = InvestorSidebarOptions()
  const {getDateValue} = useDateFormat()
  const navigate = useNavigate()
  const selectOptionFunction = (selected: number) => {
    setSelectedOption(selected)
  }
  return (
    <div className='d-md-flex'>
      <InnerSidebar
        selectOptionFunction={selectOptionFunction}
        sidebarOptions={updateSidebarOptions}
        selectedOption={selectedOption}
      />
      <div className={`card mt-4  ms-0 w-100`}>
        {/* begin::Header */}

        {/* end::Header */}
        {/* begin::Body */}
        <div className='card-body d-flex flex-column justify-content-between'>
          {/* begin::Table container */}
          <div className=''>
            {/* begin::Table */}
            <table className='table table-row-bordered table-row-gray-300 align-middle gs-0 gy-3 '>
              {/* begin::Table head */}
              <thead>
                <tr className='fw-normal text-muted '>
                  <th>{formatMessage({id: 'Title'})}</th>
                  <th>{formatMessage({id: 'Created On'})}</th>
                  <th>{formatMessage({id: 'Published By'})}</th>
                  <th>{formatMessage({id: 'Status'})}</th>
                  <th>{formatMessage({id: 'Click Counts'})}</th>
                  <th>{formatMessage({id: 'View Count'})}</th>
                  <th>{formatMessage({id: 'Update Type'})}</th>
                </tr>
              </thead>
              {/* end::Table head */}
              {/* begin::Table body */}
              <tbody>
                {investorUpdatesData?.map((investorUpdate: InvestorUpdatesModel) => (
                  <tr className='table-tbody-row' key={investorUpdate.updateId}>
                    <td>{investorUpdate.title}</td>
                    <td>
                      {investorUpdate.createdAt
                        ? getDateValue(new Date(investorUpdate.createdAt).toISOString()?.toString())
                          ? getDateValue(
                              new Date(investorUpdate.createdAt).toISOString()?.toString()
                            )
                          : DateTime.fromISO(
                              new Date(investorUpdate.createdAt).toISOString()?.toString()
                            ).toLocaleString(DateTime.DATE_MED)
                        : '-'}{' '}
                    </td>
                    <td>
                      {/* <DisplayImage
                        imgName={investorUpdate?.user?.file?.name}
                        width='24px'
                        height='24px'
                        alt='profile'
                        fit='contain'
                      /> */}
                      <OverlayTrigger
                        placement='bottom'
                        overlay={
                          <Tooltip id='tooltip'>
                            <p className='m-0'>
                              {investorUpdate?.user?.firstName} {investorUpdate?.user?.lastName}
                            </p>
                          </Tooltip>
                        }
                      >
                        <img
                          src={`${GET_FILE_URL}/${encodeURIComponent(
                            investorUpdate?.user?.file?.name || ''
                          )}`}
                          height='20'
                          width='20'
                          alt='user'
                          style={{objectFit: 'contain'}}
                          className='ms-5'
                        />
                      </OverlayTrigger>
                    </td>
                    <td>
                      <span
                        className={`badge ${
                          investorUpdate.status === 'DRAFT'
                            ? 'draft-badge'
                            : investorUpdate.status === 'PUBLISHED'
                            ? 'publish-badge'
                            : investorUpdate.status === 'UNPUBLISHED'
                            ? 'in-progress-badge'
                            : ''
                        }`}
                      >
                        {investorUpdate.status}
                      </span>
                    </td>
                    <td>{investorUpdate.clicks}</td>
                    <td>{investorUpdate.views}</td>
                    <td>
                      <span
                        className={`badge ${
                          investorUpdate.type === 'INTERNAL'
                            ? 'internal-badge'
                            : investorUpdate.type === 'EXTERNAL'
                            ? 'external-badge'
                            : ''
                        }`}
                      >
                        {investorUpdate?.type}
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
              {/* end::Table body */}
            </table>
            {/* end::Table */}
          </div>
          {/* end::Table container */}
          <div className='d-md-flex justify-content-md-end d-flex justify-content-center  w-100 mt-10 '>
            <button
              className='btn btn-primary fw-normal fs-md-7 fs-5 w-100 h-50px w-md-150px'
              onClick={() => navigate('/updates/update')}
            >
              {formatMessage({id: 'View All Updates'})}
            </button>
          </div>
        </div>
        {/* begin::Body */}
      </div>
    </div>
  )
}
